module.exports = __webpack_public_path__ + "img/12.5838ab58.jpg";